export const allowedPages = ["requisites", "collections", "naming-settings"]
